import { render, staticRenderFns } from "./DatabaseTables.vue?vue&type=template&id=275a0850&scoped=true"
import script from "./DatabaseTables.vue?vue&type=script&lang=js"
export * from "./DatabaseTables.vue?vue&type=script&lang=js"
import style0 from "./DatabaseTables.vue?vue&type=style&index=0&id=275a0850&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275a0850",
  null
  
)

export default component.exports